export enum DesktopClientPlatform {
  Windows = 'win',
  MacOS = 'mac',
}
